import { toast } from 'react-toastify';
import { ErrorMessageDataType } from 'shared/types';
import { transactionsApi } from 'entities/transactions';

const uploadBonusApi = transactionsApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadBonus: builder.mutation({
      query: (params) => {
        const formData = new FormData();
        formData.append('file', params.file);
        return {
          url: `/promo-b2b/admin/promo-b2b/admin/activities/${params.id}/import/bonuses/`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (result, error) => {
        const error_message = error?.data as ErrorMessageDataType;
        if (error) {
          toast.error(error_message.detail, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Файл успешно принят в обработку. Вы можете проверить его статус в Загрузках.', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return ['BonusPromo'];
      },
    }),
  }),
});

export const { useUploadBonusMutation } = uploadBonusApi;
